<template>
  <v-card flat>
    <v-toolbar flat dense>
      <v-spacer></v-spacer>
      <v-btn fab small @click="isEditing = !isEditing">
        <v-icon v-if="isEditing" color="primary"> mdi-close </v-icon>
        <v-icon v-else color="primary"> mdi-pencil </v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text>
      <v-text-field
        :disabled="!isEditing"
        label="Name"
        v-model="constructDetails.name"
        outlined
      ></v-text-field>
      <v-row>
        <v-col>
          <v-text-field
            :disabled="true"
            label="Date Created"
            :value="formatDate(constructDetails.created_at)"
            outlined
          ></v-text-field>
        </v-col>
        <v-col>
          <v-text-field
            :disabled="true"
            label="Last Updated"
            :value="formatDate(constructDetails.updated_at)"
            outlined
          ></v-text-field>
        </v-col>
      </v-row>
      <v-text-field
        :disabled="true"
        label="Construct Framework"
        v-bind:value="parseConstructType(constructDetails.construct_type_id)"
        outlined
      ></v-text-field>
      <v-textarea
        :disabled="!isEditing"
        label="Definition"
        v-model="constructDetails.definition"
        auto-grow
        outlined
      ></v-textarea>
      <v-checkbox
        :disabled="!isEditing"
        v-model="constructDetails.is_observable"
        label="Is Observable"
        outlined
      ></v-checkbox>
      <v-autocomplete
        :disabled="!isEditing"
        label="Parent Construct"
        v-model="constructDetails.parent_construct_id"
        :placeholder="
          parseParentConstructId(constructDetails.parent_construct_id)
        "
        :items="getRelevantParentConstructs()"
        :item-text="(construct) => construct.name"
        :item-value="(construct) => construct.id"
        clearable
        persistent-placeholder
        outlined
      >
        <template v-slot:item="{ item }">
          <v-list-item-content>
            <v-list-item-title v-text="item.name"></v-list-item-title>
            <v-list-item-subtitle>
              Parent:
              {{
                parseParentConstructId(item.parent_construct_id)
              }}</v-list-item-subtitle
            >
          </v-list-item-content>
        </template></v-autocomplete>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn :disabled="!isEditing" color="secondary" @click="deleteConstruct">
        Delete
      </v-btn>
      <v-btn :disabled="!isEditing" color="primary" @click="save"> Save </v-btn>
    </v-card-actions>
    <v-snackbar v-model="hasSaved" :timeout="2000" absolute bottom left>
      Your changes have been saved.
    </v-snackbar>
    <v-snackbar v-model="hasDeleted" :timeout="2000" absolute bottom left>
      Construct has been deleted.
    </v-snackbar>
  </v-card>
</template>

<script>
import { Bus } from '@/bus'

export default {
  props: ['constructDetails', 'constructs', 'constructTypes'],
  data () {
    return {
      hasSaved: false,
      hasDeleted: false,
      isEditing: null
    }
  },
  methods: {
    save () {
      try {
        if (this.constructDetails.construct_task_item_mapping.length === 0) {
          delete this.constructDetails.construct_task_item_mapping
        }
        this.$store.dispatch('bcm/updateConstruct', this.constructDetails)
      } catch (err) {
        Bus.$emit('alert', {
          color: 'error',
          message: 'Failed to update Construct in Blueprint Content Manager'
        })
      } finally {
        this.isEditing = !this.isEditing
        this.hasSaved = true
      }
    },
    deleteConstruct () {
      if (
        confirm(
          `Are you sure you want to delete ${this.constructDetails.name}?`
        )
      ) {
        try {
          this.$store.dispatch('bcm/deleteConstruct', [
            this.constructDetails.id
          ])
        } catch (err) {
          Bus.$emit('alert', {
            color: 'error',
            message: 'Failed to delete Construct in Blueprint Content Manager'
          })
        } finally {
          this.isEditing = !this.isEditing
          this.hasDeleted = true
          this.$router.push('/bcm')
        }
      }
    },
    async parseConstructType (constructTypeId) {
      const matchedConstructType = await this.constructTypes.find(
        (constructType) => constructType.id === parseInt(constructTypeId)
      )
      if (matchedConstructType) {
        return matchedConstructType.name
      }
    },
    async getConstructTypeMap () {
      const constructTypeMap = await [
        ...new Set(
          this.constructTypes.map((constructType) => ({
            name: constructType.name,
            construct_type_id: constructType.id
          }))
        )
      ]
      return constructTypeMap
    },
    async parseParentConstructId (parentConstructId) {
      const matchedConstruct = await this.constructs.find(
        (construct) => construct.id === parseInt(parentConstructId)
      )
      if (matchedConstruct) {
        return matchedConstruct.name
      } else {
        return 'None'
      }
    },
    async getRelevantParentConstructs () {
      const parentConstructs = await this.constructs.filter(
        (construct) =>
          parseInt(construct.construct_type_id) ===
            parseInt(this.constructDetails.construct_type_id) &&
          parseInt(construct.id) !== parseInt(this.constructDetails.id)
      )
      return parentConstructs
    },
    formatDate (dateString) {
      var options = { year: 'numeric', month: 'long', day: 'numeric' }
      const parsedDate = new Date(dateString)
      return parsedDate.toLocaleString('en-US', options)
    }
  }
}
</script>
